// Comunidades autónomas y sus provincias, para los selects en cascada de la ficha de club y los
// filtros del ranking de jugadores. Lista fija (no sale de la base de datos) porque es
// información administrativa pública que no cambia.
export const SPAIN_PROVINCES_BY_COMUNIDAD: Record<string, string[]> = {
  Andalucía: ["Almería", "Cádiz", "Córdoba", "Granada", "Huelva", "Jaén", "Málaga", "Sevilla"],
  Aragón: ["Huesca", "Teruel", "Zaragoza"],
  Asturias: ["Asturias"],
  "Islas Baleares": ["Islas Baleares"],
  Canarias: ["Las Palmas", "Santa Cruz de Tenerife"],
  Cantabria: ["Cantabria"],
  "Castilla-La Mancha": ["Albacete", "Ciudad Real", "Cuenca", "Guadalajara", "Toledo"],
  "Castilla y León": ["Ávila", "Burgos", "León", "Palencia", "Salamanca", "Segovia", "Soria", "Valladolid", "Zamora"],
  Cataluña: ["Barcelona", "Girona", "Lleida", "Tarragona"],
  "Comunidad Valenciana": ["Alicante", "Castellón", "Valencia"],
  Extremadura: ["Badajoz", "Cáceres"],
  Galicia: ["A Coruña", "Lugo", "Ourense", "Pontevedra"],
  Madrid: ["Madrid"],
  "Región de Murcia": ["Murcia"],
  "Comunidad Foral de Navarra": ["Navarra"],
  "País Vasco": ["Álava", "Guipúzcoa", "Vizcaya"],
  "La Rioja": ["La Rioja"],
  Ceuta: ["Ceuta"],
  Melilla: ["Melilla"],
};

export const SPAIN_COMUNIDADES = Object.keys(SPAIN_PROVINCES_BY_COMUNIDAD);
